// extracted by css-extract-rspack-plugin
export default {"headerContainer":"_606cf902","larger":"_c4c31395","left":"_7fa20521","titleWrapper":"_6ec57649","title":"_102fe5a","large":"_ce8c6b67"};